import { render, staticRenderFns } from "./DTEvent.vue?vue&type=template&id=3a69fa79&scoped=true"
import script from "./DTEvent.vue?vue&type=script&lang=js"
export * from "./DTEvent.vue?vue&type=script&lang=js"
import style0 from "./DTEvent.vue?vue&type=style&index=0&id=3a69fa79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a69fa79",
  null
  
)

export default component.exports